// extracted by mini-css-extract-plugin
module.exports = {"title":"MainInfo_title__1y6qx","content":"MainInfo_content__iVpLe"};